export default __webpack_public_path__ + "static/media/p-minus-2.54673da1.svg";